import React, { memo } from 'react'
import { string } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const Community = memo(({ height = '88px', width = '125px' }) => {
	const {
		colors: { primary, secondary },
	} = useTheme()

	return (
		<svg
			width={width}
			height={height}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 99.2 69.6"
			style={{ enableBackground: 'new 0 0 99.2 69.6' }}
			xmlSpace="preserve"
		>
			<g>
				<g>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M81.1,14.2c-5,0-9.1,4.1-9.1,9.1v4.8c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-4.8
						C90.2,18.2,86.1,14.2,81.1,14.2z"
					/>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M91.8,36.5l2.5,1.1c1.8,0.5,3.4,1.5,3.4,3.4v3.7c0,1.9-1.5,3.4-3.4,3.4H78.7"
					/>
				</g>
				<g>
					<g>
						<path
							fill={secondary}
							d="M71.2,40.5l-6.4-1.8l-0.1,1.4c3.1,1,5.9,2.8,5.9,6v6.7c0,2.5-1.5,4.5-3.5,5.5h4.1c3.1,0,5.7-2.5,5.7-5.7
							v-6.3C76.9,43.1,74.2,41.4,71.2,40.5z"
						/>
					</g>
					<g>
						<path
							fill={secondary}
							d="M50.1,1.5c-1.3,0-2.6,0.2-3.8,0.5c6.6,1.7,11.5,7.7,11.5,14.8v8.1c0,7.1-4.9,13.1-11.5,14.8
							c1.2,0.3,2.5,0.5,3.8,0.5c8.5,0,15.3-6.9,15.3-15.3v-8.1C65.4,8.4,58.6,1.5,50.1,1.5z"
						/>
					</g>
					<path
						fill="none"
						stroke={secondary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M50.1,1.5c-8.5,0-15.3,6.9-15.3,15.3v8.1c0,8.5,6.9,15.3,15.3,15.3c8.5,0,15.3-6.9,15.3-15.3v-8.1
						C65.4,8.4,58.6,1.5,50.1,1.5z"
					/>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M34.4,58.7h-6.8c-3.2,0-5.7-2.6-5.7-5.7v-6.2c0-3.2,2.7-4.8,5.7-5.7l6.7-1.8"
					/>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M66,39.2l6.4,1.8c3,0.9,5.7,2.6,5.7,5.7V53c0,3.2-2.6,5.7-5.7,5.7h-7.3"
					/>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M50.1,1.5c-8.5,0-15.3,6.9-15.3,15.3v8.1c0,8.5,6.9,15.3,15.3,15.3c8.5,0,15.3-6.9,15.3-15.3v-8.1
						C65.4,8.4,58.6,1.5,50.1,1.5z"
					/>
				</g>
				<g>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M18.2,14.2c-5,0-9.1,4.1-9.1,9.1v4.8c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-4.8
						C27.3,18.2,23.2,14.2,18.2,14.2z"
					/>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M21.3,48.1H4.9c-1.9,0-3.4-1.5-3.4-3.4V41c0-1.9,1.6-2.9,3.4-3.4l2.7-1.1"
					/>
				</g>
			</g>
			<g>
				<g>
					<path
						fill="none"
						stroke={primary}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M49.6,68.1c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S55.2,68.1,49.6,68.1z"
					/>
					<g>
						<line
							fill="none"
							stroke={primary}
							strokeWidth={3}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeMiterlimit={10}
							x1="49.6"
							y1="62.3"
							x2="49.6"
							y2="53.9"
						/>
					</g>
					<g>
						<line
							fill="none"
							stroke={primary}
							strokeWidth={3}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeMiterlimit={10}
							x1="53.8"
							y1="58.1"
							x2="45.4"
							y2="58.1"
						/>
					</g>
				</g>
			</g>
		</svg>
	)
})

Community.propTypes = {
	height: string,
	width: string,
}
